import { API_ROOT_URL } from "../config";
import { handleResponse } from "../helpers";

export const familyMemberService = {
    getFamilyMembers,
    addFamilyMember,
    deleteFamilyMember,
    getRelationList
};

function getFamilyMembers() {
    const token = JSON.parse(localStorage.getItem("token"));
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: "Bearer " + token
        }
    };
    return fetch(`${API_ROOT_URL}/patients/family-members/`, requestOptions)
        .then(handleResponse)
        .then((familyMembers) => {
            return familyMembers;
        });
}
function addFamilyMember(memberData) {
    const token = JSON.parse(localStorage.getItem("token"));

    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token
        },
        body: JSON.stringify(memberData)
    };

    return fetch(`${API_ROOT_URL}/patients/family-members/`, requestOptions)
        .then(res => {
            return res.text().then(text => {
                const data = text && JSON.parse(text);
                if (!res.ok) {
                    return Promise.reject(data);
                }
                return data;
            });
        });
}
function deleteFamilyMember(member_id) {
    const token = JSON.parse(localStorage.getItem("token"));

    const requestOptions = {
        method: "DELETE",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: "Bearer " + token
        }
    };
    return fetch(`${API_ROOT_URL}/patients/family-members/${member_id}/`, requestOptions)
        .then(res => {
            return res.text().then(text => {
                const data = text && JSON.parse(text);
                if (!res.ok) {
                    return Promise.reject(data); // Reject with the error data
                }
                return data;
            });
        });
}
function getRelationList() {
    const token = JSON.parse(localStorage.getItem("token"));
    
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: "Bearer " + token
        }
    };
    return fetch(
        `${API_ROOT_URL}/patients/relations/`,
        requestOptions
    )
        .then(handleResponse)
        .then(memberRelation => {
            return memberRelation;
        });
}


// WEBPACK FOOTER //
// ./src/services/familyMember.service.js